<template>
  <div class="outer">

    <!-- 我的收货地址 -->
    <div class="box" v-for="(info, index) in addrArr">
      <div class="addr">
        <div class="txt" @click="selectedDef(index)">
          <div class="area">{{info.province+' '+info.city+' '+info.county+' '+info.town}}</div>
          <div class="ddr-detail">{{info.detail}}</div>
          <div class="user">{{info.username+' '+info.phone}}</div>
        </div>
        <div class="edit-btn" @click="edit(info)"><img src="../../assets/img/my_addr/edit.png" alt="edit"></div>
      </div>
      <div class="addr-bottom">
        <div class="set-def" @click="selectedDef(index)">
          <img :src="+info.is_default ? require('../../assets/img/signup/selected.png') : require('../../assets/img/signup/unselected.png') " alt="sel-def">
          <span>默认地址</span>
        </div>
        <div class="del" @click="network().userAreaDelete(info.area_id, index)"><img src="../../assets/img/my_addr/del.png" alt="del"></div>
      </div>
    </div>

    <!-- 新增地址 -->
    <div class="box">
      <div class="newAddr" @click="navigateTo('addMyAddr')">
        <div class="content">
          <img class="add-addr-img" src="../../assets/img/order_filling/ic_add@2x.png" alt="新增地址">
          <div>新增地址</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {userAreaDelete, userAreaEdit, userAreaGetList} from '../../api/api'
import utils from "../../jslib/utils"
export default {
  name: "MyAddr",
  data(){
    return{
      addrArr: [],
    }
  },
  created() {
    this.network().userAreaGetList()
  },
  methods:{
    selectedDef(index){
      let addr = JSON.parse(JSON.stringify(this.addrArr[index]))
      // addr.is_default = +!+this.addrArr[index].is_default
      addr.is_default = 1
      this.network().editAddr(addr, index)
    },

    edit(data){
      let {area_id, username, phone, province, province_id, city, county, county_id, town, detail, is_default} = data
      this.navigateTo(`addMyAddr?area_id=${area_id}&username=${username}&phone=${phone}&province=${province}&province_id=${province_id}&city=${city}&county=${county}&county_id=${county_id}&town=${town}&detail=${detail}&is_default=${is_default}`)
    },

    network(){
      return{
        userAreaGetList: async ()=>{
          let {data} = await userAreaGetList()
          console.log('获取用户收货地址', data)

          let {code, message} = data
          if(code == 200){
            this.handle().userAreaGetList(data.data)
          }else{
            this.$uihelper.toast(message)
          }
        },

        // 删除地址
        userAreaDelete: async (area_id, index) => {
          let {data} = await userAreaDelete({area_id})
          console.log('删除地址', data)

          let {code, message} = data
          if(code == 200){
            this.addrArr.splice(index, 1)
          }else{
            this.$uihelper.toast(message)
          }
        },

        // 更新地址 (选择默认)
        editAddr: async (param, index) => {
          let {data} = await userAreaEdit(param)
          console.log('更新地址', data)

          data = utils.dealWithErrorDate(data)  // fixme 后台返回数据格式有误

          let {message, code} = data
          if(code == 200){
            this.handle().selectedDef(index)  // 设置完成后
          }else {
            this.$uihelper.toast(message)
          }
        },
      }
    },
    handle(){
      return{
        userAreaGetList: data => {
          this.addrArr = data.area_list
        },
        selectedDef: index => {
          for(let i in this.addrArr){
            if(index != i) this.addrArr[i].is_default = 0
          }
          // this.addrArr[index].is_default = +!+this.addrArr[index].is_default
          this.addrArr[index].is_default = 1
          this.navigateBack()
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./myAddr";
</style>
